export const ForbiddenIcon = () => (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="24" fill="#FF8266" />
        <path d="M31.8 16.2L16.2 31.8" stroke="#A4343A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M24 35C30.0751 35 35 30.0751 35 24C35 17.9249 30.0751 13 24 13C17.9249 13 13 17.9249 13 24C13 30.0751 17.9249 35 24 35Z" stroke="#A4343A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);
